import {doc, getDoc} from "firebase/firestore";
import {firestore} from "./Firebase";

export function getUserExperimentId(): string {
    let existingId = localStorage.getItem("userExperimentId");
    if (!existingId) {
        const newId = crypto.randomUUID();
        localStorage.setItem("userExperimentId", newId);
        return newId;
    }
    return existingId;
}

export async function syncUserExperimentIdFromFirebase(userId: string) {
    const userDoc = await getDoc(doc(firestore, "users", userId));
    if (userDoc.exists()) {
        const data = userDoc.data();
        if (data.experimentId) {
            localStorage.setItem("userExperimentId", data.experimentId);
        }
    }
}